import React from 'react'

import { withActions } from '../../../WithActions';
import MediaRecordingActions from "../../../actions/MediaRecordingActions";

import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import { grey } from '@material-ui/core/colors';
import { fade } from '@material-ui/core/styles/colorManipulator';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import screenIcon from './img/screen.svg';
//import screenCamIcon from './img/screenCam.svg';
import camIcon from './img/cam.svg';

const styles = (theme: Theme) => ({
  source: {
    fontSize: '12px',
  },
  gridList: {
    height: 'auto',
  },
  titleBar: {
    'text-align': 'center',
      backgroundColor: 'transparent'  
  },
  titlePosition: {
    top: '28%',
    [theme.breakpoints.up('sm')]: {
      top: '35%'
    },
  },
  box: {
    height: '100%',
    borderRadius: '5px',
    backgroundColor: fade(grey[100], 0.9),
    '&:hover': {
      boxShadow: theme.shadows[2],
      cursor: 'pointer',
    }
  },
  cardActionArea: {
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      height: 149
    },
  },
  cardSelected: {
    backgroundColor: fade(theme.palette.primary.main, 0.9),
  },
  iconLg: {
    height: 35,
    width: 35
  }
});

interface Sources {
  label: string,
  svgSrc: string
}

const sources:Sources[] = [
  //{ label: 'Screen + Cam', svgSrc: screenCamIcon },
  { label: 'Screen', svgSrc: screenIcon },
  { label: 'Camera', svgSrc: camIcon }
];

interface Props {
  actions: MediaRecordingActions;
  width: string,
  handleChangeSourceSelected: (index: number) => void,
  sourceSelected: number,
  recorderStatus: string
}

type PropsWithStyles = Props & WithStyles<'source' | 'gridList' | 'titleBar' | 'titlePosition' | 'box' | 'cardActionArea' | 'cardSelected' | 'iconLg'>;

class RecorderSources extends React.Component<PropsWithStyles> {

render() {
  const { classes, width } = this.props;
  
  const renderRecorderSources = () => {
    return sources.map((item, index) => {

      return (
        <Card key={index} elevation={0} className={this.props.sourceSelected === index ? classes.cardSelected : ''}>
          <CardActionArea className={classes.cardActionArea}>
              <GridListTile 
                cols={1}
                className={classes.box}
                onClick={() => this.props.handleChangeSourceSelected(index)}
              >
                <GridListTileBar
                  title={<Box color={this.props.sourceSelected === index ? 'primary.main' : grey[600]}>
                    <img className={classes.iconLg} src={item.svgSrc} alt={item.label}/>
                    <div>{item.label}</div>
                  </Box>}
                  titlePosition="top"
                  className={classes.titleBar}
                  classes={{
                    titlePositionTop: classes.titlePosition
                  }}
                />
              </GridListTile>
          </CardActionArea>
        </Card>
                
      )
    })
  }

  return (
    this.props.recorderStatus !== 'recording' ? (
    <div className={classes.source}>
      <GridList cellHeight={width === 'xs' ? 100 : 150} cols={width === 'sm' ? 1 : 2} className={classes.gridList} spacing={8}>
        {renderRecorderSources()}
      </GridList>
    </div>) : (<span />)
  );
}

}

export default withActions(withWidth()(withStyles(styles)(RecorderSources)));  
